<template>
  <div class="wrapper">
    <h2>
      Manage projects
      <el-button type="primary" @click="newProject">
        New Project
      </el-button>
    </h2>

    <div class="projects-owner">
      <el-row type="flex" justify="space-around" :gutter="20">
        <el-col v-for="role in rolesOwner" :key="role.id" :span="12">
          <AccountProject :role="role" @click="$router.push('/?roleId=' + $event)" />
        </el-col>
      </el-row>

      <el-divider content-position="left">Team</el-divider>

      <el-row v-if="rolesTeam.length > 0" :gutter="20">
        <el-col v-for="role in rolesTeam" :key="role.id" :span="8">
          <AccountProject :role="role" small @click="$router.push('/?roleId=' + $event)" />
        </el-col>
      </el-row>

      <el-alert
        v-else
        type="info"
        title="You have not yet been invited to collaborate on an external project"
        :closable="false"
        show-icon
      />
    </div>

    <el-dialog
      custom-class="request-upgrade-popup"
      title="Upgrade your account"
      :visible.sync="upgrade"
    >
      <BillingUpgrade
        :show-enterprise="false"
        request-access="more projects"
        @upgrade="newProject"
      />
    </el-dialog>

    <el-dialog
      title="Create Owner project"
      :visible.sync="create"
      width="510px"
      top="5vh"
    >
      <AccountStart v-if="rolesOwner.length === 0" @save="create = false" />

      <template v-else>
        <el-form>
          <el-input
            v-model="name"
            placeholder="Name your new project"
          />
        </el-form>

        <div slot="footer">
          <el-button @click="create = false">
            Cancel
          </el-button>
          <el-button type="primary" :loading="loading" @click="createProject">
            Create Project
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BillingUpgrade from '../components/Billing/Upgrade'
import AccountProject from '../components/Account/Project'
import AccountStart from '../components/Account/Start'

export default {
  components: {
    BillingUpgrade,
    AccountProject,
    AccountStart
  },
  data () {
    return {
      name: null,
      create: false,
      upgrade: false,
      loading: false
    }
  },
  computed: {
    rolesOwner () {
      return (this.user.roles || []).filter((r) => r.access === 1)
    },
    rolesTeam () {
      return (this.user.roles || []).filter((r) => r.access !== 1)
    },
    ...mapState(['client', 'user']),
    ...mapGetters(['permission'])
  },
  methods: {
    newProject () {
      this.create = !!this.client.team
      this.upgrade = !this.client.team
    },
    createProject () {
      if (!this.name) {
        return
      }

      this.loading = true
      this.$store.dispatch('createProject', { name: this.name })
        .then(() => {
          this.create = false
          this.loading = false
        })
    },
    updateName (name) {
      this.$store.dispatch('updateProject', { name }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  .projects-owner {
    .el-card {
      margin: 20px 0 30px;
    }
  }

  .switch {
    width: 100%;
  }

  .new-project {
    margin-top: 24px;

    .el-input {
      width: calc(100% - 200px);
      margin-right: 10px;
    }
  }

  .account {
    background-color: $--background-color-base;
    padding: 10px;

    h3, h4 {
      margin-top: 0;
      color: $--color-text-gray;
      font-size: 12px;
      line-height: 20px;

      .el-tag {
        float: right;
      }
    }
  }

  .el-divider__text {
    background-color: $--background-color-base;
  }
</style>
